import {AbstractControlOptions, FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {Ultilities} from "../extensions/ultilities";

export abstract class BaseFormComponent {
  public myForm!: FormGroup;
  arrayName!: string;
  controlArrName!: string;

  constructor(
    protected fb: FormBuilder
  ) {

  }

  createItem!: (item: any) => FormGroup;

  createForm(controlsConfig: { [key: string]: any; }, options?: AbstractControlOptions | { [key: string]: any; }) {
    this.myForm = this.fb.group(controlsConfig);
  }

  get dataArr() {
    return this.myForm.get(this.controlArrName) as FormArray;
  }

  deleteRow(index: number) {
    this.dataArr.removeAt(index)
  }

  addRow(form: FormGroup) {
    this.dataArr.push(form);
  }

  setValueFormArr(value: any[]) {
    this.myForm.setControl(this.controlArrName, this.fb.array(value.map((x: any) => this.createItem(x))))
  }

  validateControl() {
  }

  validateForm(form: FormGroup = this.myForm) {
    Ultilities.validateForm(form);
    if (form.invalid) {
      return false;
    }
    return true;
  }

  downloadFilePublic(file: Blob, filename: string): void {
    const blob = new Blob([file], {type: 'application/octet-stream'});
    var link = document.createElement('a');
    document.body.appendChild(link);
    link.href = window.URL.createObjectURL(blob)
    link.setAttribute('download', filename);
    link.click();
    document.body.removeChild(link);
  }

}
